import { init as sentryInit, ErrorBoundary as SentryErrorBoundary } from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import PropTypes from 'prop-types'
import React from 'react'

sentryInit({
  dsn: process.env.SENTRY_DSN,
  integrations: [new BrowserTracing()],
  attachStacktrace: true,
  tracesSampleRate: 1.0,
})

const ErrorBoundary = ({ children }) => (
  <SentryErrorBoundary fallback={<p>An error has occurred</p>}>{children}</SentryErrorBoundary>
)

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
